import { render, staticRenderFns } from "./InvestorOccupationData.vue?vue&type=template&id=13728162&scoped=true&"
import script from "./InvestorOccupationData.vue?vue&type=script&lang=js&"
export * from "./InvestorOccupationData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOccupationData.vue?vue&type=style&index=0&id=13728162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13728162",
  null
  
)

export default component.exports